import React, { useState, useEffect, useMemo } from 'react';
import { Reactify } from '@yandex/ymaps3-types/reactify';

import ReactDOM from 'react-dom';

export const useYandexMaps = () => {
  const [reactify, setReactify] = useState<Reactify | null>(null);

  const loadYmaps3 = useMemo(
    () => async () => {
      const [ymaps3React] = await Promise.all([
        ymaps3.import('@yandex/ymaps3-reactify'),
        ymaps3.ready,
      ]);
      setReactify(ymaps3React.reactify.bindTo(React, ReactDOM));
    },
    []
  );

  useEffect(() => {
    loadYmaps3();
  }, []);

  return reactify;
};
